module.exports = __webpack_public_path__ + "static/icons/icon-resort-manager-logo--color-a807be1142f5680819d3a5669aeedb43.svg";